import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, copy, align = "left" }) => (
  <Reveal className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <p className="font-mono text-xs uppercase tracking-[0.25em] text-cyan-400" data-testid={`overline-${overline.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      {overline}
    </p>
    <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-50">
      {title}
    </h2>
    {copy && <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed">{copy}</p>}
  </Reveal>
);
